import {BaseModel} from '@/models/base.model';
import {UserModel} from '@/models/user.model';

export class TopicModel extends BaseModel {
    constructor(public topic: string = '',
                public user?: UserModel,
                public description?: string,
                public replies?: number,
                public challenge_id?: number,
                public last_post?: {
                    contestant_name?: string;
                    created_at?: string;
                    updated_at?: string;
                }) {
        super();
    }
}


export interface TopicEvents {
    topic?: TopicModel;
    edit?: boolean;
    remove?: boolean;
    add?: boolean;
    show?: boolean;
    showTable?: boolean;
}
